// extracted by mini-css-extract-plugin
export var quantityInput = "_ej-0";